import React from "react";
import { Navigate } from "react-router-dom";
import { useToken } from "./TokenContext";

const PrivateRoute = ({ element }) => {
  const { isAuthenticated, isLoading } = useToken();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.warn("[PrivateRoute] 未認証のため / にリダイレクト");
    return <Navigate to="/useraccess" replace />;
  }

  return element; // ✅ JSX をそのまま返す
};

export default PrivateRoute;
